import actions from './actions';

const state = {
  
};

export default {
  namespaced: true,
  state,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/rangeBoxGeneral/index.js